import React, { useEffect, useState } from 'react';
import api from '../api';
import { getErrorMessage } from '../types';
import { useTranslation } from '../i18n';

interface Props {
  consent: boolean;
  loading: boolean;
}

/** Saves on every change, independently of the settings form, so consent is never left unsaved. */
export const MarketingConsentSection: React.FC<Props> = ({ consent, loading }) => {
  const { t } = useTranslation();
  const [checked, setChecked] = useState(consent);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [saved, setSaved] = useState(false);

  useEffect(() => setChecked(consent), [consent]);

  const handleChange = async (next: boolean) => {
    setBusy(true);
    setError('');
    setSaved(false);
    try {
      await api.put('/users/marketing-consent', { consent: next });
      setChecked(next);
      setSaved(true);
    } catch (err) {
      setError(getErrorMessage(err, t('marketing_consent.save_error')));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="card" style={{ marginTop: '1rem' }}>
      <h3 style={{ marginTop: 0 }}>{t('marketing_consent.title')}</h3>
      {error && <div className="alert alert-error">{error}</div>}
      <label style={{ display: 'flex', alignItems: 'flex-start', gap: '0.5rem', fontSize: '0.9rem', cursor: 'pointer' }}>
        <input
          type="checkbox"
          checked={checked}
          onChange={e => handleChange(e.target.checked)}
          disabled={busy || loading}
          style={{ marginTop: '0.2rem' }}
        />
        <span>{t('marketing_consent.label')}</span>
      </label>
      {saved && <p className="text-muted" style={{ fontSize: '0.85rem', margin: '0.5rem 0 0' }}>{t('marketing_consent.saved')}</p>}
    </div>
  );
};
